// reducer.js
import * as constants from './constants';

const INITIAL_STATE = {
  visible: false,
  content: null,
  title: '',
  onClose: null,
  cancelButtonText: 'TUTUP',
  mobileModalHeightClassName: 'h-full',
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_CONFIRMATION_MODAL:
      return {
        ...state,
        ...action.payload,
      };
    case constants.SET_INIT_VALUE_CONFIRMATION_MODAL:
      return {
        ...state,
        visible: false,
        content: null,
        title: '',
        mobileModalHeightClassName: 'h-full',
        onClose: () => {},
        cancelButtonText: 'TUTUP',
      };
    default:
      return state;
  }
};

export default reducer;
